module.exports = __webpack_public_path__ + "static/9-83468a0a1d45a764596c3433abc1e6ad.png";